// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const porygon2: PokeData = {
  "id": 233,
  "name": "porygon2",
  "height": 6,
  "weight": 325,
  "base_experience": 180,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "psybeam",
    "hyper-beam",
    "thunder-shock",
    "agility",
    "recover",
    "defense-curl",
    "conversion",
    "tri-attack",
    "conversion-2",
    "zap-cannon",
    "lock-on",
    "magic-coat",
    "recycle",
    "signal-beam",
    "magnet-rise",
    "discharge"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "tri-attack",
    "zap-cannon",
    "purification",
    "quick-attack",
    "supersonic",
    "splash",
    "scratch",
    "scary-face",
    "protect",
    "leer",
    "growl"
  ],
  "evolution_chain": {
    "id": 68,
    "item": null,
    "species": [
      {
        "name": "porygon",
        "order": 166,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "porygon2",
        "order": 167,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 137,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "porygon-z",
        "order": 168,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 233,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 88.75,
    "speed": 60,
    "ability_power": 105
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
